<template>
  <v-dialog persistent :value="editRole" width="800">
    <popup-heading 
      title="LOCATION ROLES" 
      subtitle="Set the users roles for each location.">
      <template slot="action">
        <v-btn
          depressed
          @click="closeModal()"
          fab 
          color="white"
          :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
        >
          <v-icon dark class="primary--text">close</v-icon>
        </v-btn>
        <v-btn
          depressed
          @click="updateUserLocationRoles()"
          fab 
          color="white"
          :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
        >
          <v-icon dark class="primary--text">check</v-icon>
        </v-btn>
      </template>
    </popup-heading>
    
    <v-card class="elevation-0 px-4 py-5" v-if="loading">
      <block-spinner></block-spinner>
    </v-card>

    <v-card class="elevation-0 px-4" v-else>
      <v-layout wrap>
      <v-flex sm12 md12>
        <v-text-field
          class="search-input"
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex sm12 md12>
        <div class="text-center">
          <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
        </div>
        <v-data-table
          :headers="headers"
          :items="displayLocationsRoles"
          :search="search"
          class="pb-4 tabulardata dark-heading text-center"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="listItem in items" :key="listItem.name">
              <td width="40">
                <v-checkbox 
                class="tbl-chekbox"
                color="primary"
                :label="listItem.location_name"
                v-model="listItem.checked"
                ></v-checkbox>
              </td>
              <td width="300">
            
                <v-select
                  v-model="listItem.roles"
                  :items="allRoles"
                  item-text="name"
                  item-value="id"
                  chips
                  multiple
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                    <span>{{ item.name }} </span>
                    </v-chip>
                    <span
                      v-if="index === 1"
                      class="grey--text caption"
                    > (+{{ listItem.roles.length - 1 }} others)</span>
                  </template>
                </v-select>
              </td>
              </tr>
            </tbody>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            No results.
          </v-alert>
        </v-data-table>
      </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helpers from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty , indexOf, uniqueId} from 'lodash';

export default {
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Location', value: 'location_name', sortable: false, class: 'font-weight-bold' },
        { text: 'Roles', value: '', sortable: false, class: 'font-weight-bold' },
      ],
      loading: false,
      displayLocationsRoles: [],
      existingLocationRole: [],
    };
  },
  computed: {
    
    ...mapGetters({
      editRole: 'user/editRole',
      editRoleObj: 'user/editRoleObj',
      locationList: 'location/list',
      allRoles: 'role/list',
    }),
  },

  created() {
    this.fetchRoles();
    this.fetchLocations();
    this.closeModal();
  },

  watch:{
    displayLocationsRoles: {
      handler: function (val ) {
        val.map(item => {
          if(item.roles.length > 0) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        })
      },
      deep: true
    }, 


    'editRoleObj': function(val){
      if(!_.isEmpty(val)){
        this.loading = true;
        // To get latest location 
        this.fetchExistingLocationRoles(val.id);
      }
    }
  },
  methods: {
  
     /**
     * Get all business locations, in case its not fetched
     */
    fetchLocations() {
      const url = `${Env.url}/api/v1/locations/${ this.$store.getters.getLoggedInUserSelectedBusinessId }`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setLocationList(res.data.payload);
      })
      .catch((err) => {
        console.log('Unable to fetch locations');
      });
    },

    /**
     * Get all business roles, in case its not fetched
     */
    fetchRoles() {
      const url = `${Env.url}/api/v1/roles`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setRoleList(res.data.payload);
      })
      .catch((err) => {
        console.log('Unable to fetch roles');
      });
    },

    /**
     * Fetch this user location roles
     */
    fetchExistingLocationRoles(userId) {
      const url = `${Env.url}/api/v1/users/${userId}/roles`;
      AuthApi.getApi(url)
        .then((res) => {
          let existingLocationRole = [];
          // Raw 
          let rawdata = res.data.payload;
          rawdata.map(item => {
            existingLocationRole.push({
              location: item.location.id,
              roles: Helpers.getUniqueArrayItems(Helpers.getInnerFieldValueInArray(item.location.userRoles, 'role', 'id')),
            })
          });
          this.existingLocationRole = existingLocationRole;
          // Now make selectable values key value pair
          this.makeLocationRoleSelectableKeyValuePair();
          this.loading = false; 
        })
        .catch((err) => {
          this.loading = false;
          // error mean no existing data
           this.makeLocationRoleSelectableKeyValuePair(); 
          console.log('Unable to fetch available locations.')
        });
    },

    /**
     * Make selectable data 
     */

    makeLocationRoleSelectableKeyValuePair() {

      let displayLocationsRoles = [];
      // Need to check pre existing 
      // Get the pre added location 
      let preAddedLocationIds = Helpers.getUniqueArrayItems(Helpers.getFieldValueInArray(this.existingLocationRole, 'location'));

      this.locationList.map(item => {
          let obj;
          // check this location is already added 
          if(_.indexOf(preAddedLocationIds, item.id) > -1) {
            obj = {
              location: item.id,
              location_name: item.name,
              checked: true,
              roles: Helpers.filterAndGetValue(this.existingLocationRole, 'location', item.id, 'roles'),
            };
          } else {
            obj = {
              location: item.id,
              location_name: item.name,
              checked: false,
              roles: [],
            };
          }
          displayLocationsRoles.push(obj)
      });
      this.displayLocationsRoles = displayLocationsRoles;
    },

    /**
     * Update location roles
     */
    updateUserLocationRoles() {
      // Before hit api need to check whether blank data 
      let error = false;
      let data = {
        access: [],
      }
      let checkedLocations = this.displayLocationsRoles.filter(item => item.checked);
      if(checkedLocations.length < 1) {
        this.snackbar({
          text: 'Please select location and their roles.',
          timeout: 4000,
          open: true,
        });
        return false;
      }

      // validate if any location is checked but not roles
     for (var i = 0; i < checkedLocations.length; i++) {
        if (checkedLocations[i].roles.length < 1) {
           this.snackbar({
            text: 'Empty role on ' + checkedLocations[i].location_name,
            timeout: 4000,
            open: true,
          });
          error = true;
          break;
        }
        data.access.push({
          location: checkedLocations[i].location,
          roles: checkedLocations[i].roles,
        })
      }

      if(error){
        return false;
      }
      this.spinner(true);
      const url = `${Env.url}/api/v1/users/${this.editRoleObj.id}/roles/multiple`;
      AuthApi.postApi(url, data)
      .then((res) => {
        this.snackbar({
          text: res.data.msg,
          timeout: 4000,
          open: true,
        });
        this.spinner(false);
        this.closeModal();
      })
      .catch((err) => {
        this.snackbar({
          text: err.response.data.msg,
          timeout: 4000,
          open: true,
        });
        this.spinner(false);
        console.log('Unable to add.')
      });
    },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      this.setEditRole(false);
      this.existingLocationRole = [];
      this.displayLocationsRoles = [];
      this.setEditRoleObj({});
    },

    ...mapActions({
      setEditRole: 'user/setEditRole',
      setEditRoleObj: 'user/setEditRoleObj',
      setRoleList: 'role/setList',
      setLocationList: 'location/setList',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>


